import React from 'react';
import { Helmet } from 'react-helmet';
import { NoteLetter } from 'modules/Notes';
import { FretboardConfig } from 'modules/Fretboard';
import StepPage from '../components/StepPage';
import FretboardPlayer, { Mode } from '../components/FretboardPlayer';

interface Props {
  canonicalUrl: string;
}

const noteLetters: NoteLetter[] = [
  'C',
  'C#',
  'Db',
  'D',
  'D#',
  'Eb',
  'E',
  'F',
  'F#',
  'Gb',
  'G',
  'G#',
  'Ab',
  'A',
  'A#',
  'Bb',
  'B',
  'C',
];

const mode: Mode = { type: 'EXERCISE_PLAYER', exerciseNoteCount: 2 };

const instructions = (bpm: number, fretboardConfig: FretboardConfig) => (
  <div>
    <p className='mb-2'>
      <span>Play&nbsp;</span>

      <strong>two different notes</strong>

      <span>&nbsp;on each string, one on&nbsp;</span>

      <strong>strings {fretboardConfig.stringTunings.length} through 1</strong>

      <span>&nbsp;and the other on&nbsp;</span>

      <strong>strings 1 through {fretboardConfig.stringTunings.length}</strong>

      <span>, at&nbsp;</span>

      <strong>{bpm} BPM</strong>

      <span> with your </span>

      <strong>first finger</strong>

      <span>.</span>
    </p>

    <p>
      <span>Move on to the next two notes when the exercise&nbsp;</span>

      <strong>starts to feel easy</strong>

      <span>.</span>
    </p>
  </div>
);

export default function Step4({ canonicalUrl }: Props) {
  return (
    <StepPage instructions={instructions}>
      <Helmet>
        <link rel='canonical' href={canonicalUrl} />
      </Helmet>

      <FretboardPlayer noteLetters={noteLetters} mode={mode} />
    </StepPage>
  );
}
